import { Position, NodeProps } from 'reactflow';
import { CardNodeData } from 'store/ducks/Global/types';
import CardComponent from './CardComponent';
import * as Styled from './Card.styled';

export const CardNode = ({ data }: NodeProps<CardNodeData>) => {
  return (
    <Styled.CardNodeDiv>
      <Styled.HandleCard type="target" position={Position.Left} id="left" />
      <Styled.HandleCard type="source" position={Position.Right} id="right" />
      <Styled.HandleCard type="target" position={Position.Top} id="top" />
      <Styled.HandleCard type="source" position={Position.Bottom} id="bottom" />
      <CardComponent area={data.title} href={data.href} textOnTop="" />
    </Styled.CardNodeDiv>
  );
};
